import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import BrandingProp from '../../commonComponents/propTypes/brandingProp';
import TermsProp from '../../commonComponents/propTypes/termsProp';
import UserProp from '../../commonComponents/propTypes/userProp';
import CourseProp from '../academy/propTypes/courseProp';
import JourneyProp from '../journey/propTypes/journeyProp';
import AcademyConfigProp from './propTypes/academyConfig';
import Title from '../../commonComponents/Title';
import Header from '../../commonComponents/pageLayout/header/Header';
import ScrollTop from '../../commonComponents/pageLayout/ScrollTop';
import Highlights from './Highlights';
import Description from './Description';
import Hero from './Hero';
import Certification from './Certification';
import Clients from './Clients';
import ContactAndAboutUs from './ContactAndAboutUs';
import LandingFooter from './LandingFooter';
import Journeys from './journeys/Journeys';
import Testimonials from './testimonial/Testimonials';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import CurrencyProp from '../profile/propTypes/currencyProp';

export default function Landing({
  theme,
  branding,
  terms,
  profile,
  languages,
  currencies,
  countries,
  academyConfig,
  highlights,
  journeys,
}) {
  const logo = branding ? branding.horizontalLogo : undefined;
  const mainContainerClass = cx(
    'm-grid__item',
    'm-grid__item--fluid',
    'm-grid m-grid--hor-desktop',
    'm-grid--desktop m-body',
  );

  return (
    <Title disableAppName title={academyConfig ? academyConfig.title : ''}>
      <>
        <Header
          theme={theme}
          logo={logo}
          languages={languages}
          currencies={currencies}
          profile={profile}
          countries={countries}
        />
        <div className={mainContainerClass}>
          <div className="landing-page-container">
            <Hero academyConfig={academyConfig} />
            <Description academyConfig={academyConfig} />
            {journeys && journeys.length > 0 ? (
              <Journeys journeys={journeys} />
            ) : null}
            <Highlights academyConfig={academyConfig} highlights={highlights} />
            <Certification />
            <Testimonials academyConfig={academyConfig} />
            <Clients academyConfig={academyConfig} />
            <ContactAndAboutUs academyConfig={academyConfig} />
            <LandingFooter
              academyConfig={academyConfig}
              terms={terms}
              branding={branding}
            />
          </div>
        </div>
        <ScrollTop />
      </>
    </Title>
  );
}

Landing.propTypes = {
  branding: PropTypes.shape(BrandingProp.propType),
  terms: PropTypes.shape(TermsProp.propType),
  theme: PropTypes.string.isRequired,
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
  highlights: PropTypes.arrayOf(PropTypes.shape(CourseProp.propType))
    .isRequired,
  journeys: PropTypes.arrayOf(PropTypes.shape(JourneyProp.propType)).isRequired,
  profile: PropTypes.shape(UserProp.propType),
  languages: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType)),
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType)),
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType)),
};

Landing.defaultProps = {
  profile: null,
  languages: [],
  currencies: [],
  countries: [],
  branding: null,
  terms: null,
};
